import type { RefObject } from "react"

import isString from "lodash-es/isString"
import { matchPath } from "react-router-dom"
import sanitizeHtml from "sanitize-html"

import { Option } from "$/models/option"
import { TranslationObj } from "$/utils/lang"

import { EUserRole } from "@/3514/types"
import { userRoutesPath } from "@/constants"

export const sanitizeContent = (content: string, attributes?: sanitizeHtml.IOptions) =>
    sanitizeHtml(content, {
        allowedAttributes: {
            "*": ["style"]
        },
        ...attributes
    })

export const isEmptyObject = (obj: any) => Object.keys(obj).length === 0

export const containsHTML = str => /<[a-z][\s\S]*>/i.test(str)

export const getLanguageOptions = (languages: TranslationObj) => {
    const defaultLanguage = [new Option({ value: "en", label: "English" })]

    const langs = Object.entries(languages).map(([langKey, label]) => new Option({ value: langKey, label }))

    if (!langs.length) {
        return defaultLanguage
    }

    return langs
}

export function transformVersionToNumber(inputStr: string): number | null {
    const match: RegExpMatchArray = inputStr.match(/\d+/g)
    if (!match || match.length !== 3) return null

    const [major, minor, patch]: Array<number> = match.map(Number)

    return major * 100000 + minor * 1000 + patch
}

export const scrollToBottom = (ref: RefObject<HTMLElement | null>, options: ScrollIntoViewOptions = {}) => {
    ref.current?.scrollIntoView({ behavior: "auto", ...options })
}

export const matchingRouteByRole = (role: EUserRole, url: string) =>
    isString(role) &&
    isString(url) &&
    userRoutesPath?.[role]?.some(route => isString(route) && Boolean(matchPath(route, url)))
